import useDirtyForm from "./useDirtyForm";

export default function DirtyFormInitializer({
	onLeavePage,
}: {
	onLeavePage: () => void;
}) {
	useDirtyForm(onLeavePage);

	return null;
}
